import actions from '../../actionTypes';

export default data => {
  return {
    type: actions.SET_GATEWAY_DETAIL,
    gatewayData: data
  };
};



// WEBPACK FOOTER //
// ./src/reducers/status/actions/setGatewayDetail.js